import { useTranslation } from 'react-i18next';
import { YStack } from 'tamagui';

import { NoInternetConnectionView } from './components/NoInternetConnectionView';
import { LogoTimeDate } from '../../components/common/LogoTimeDate';
import { ThreeCardLayout } from '../../components/layouts/ThreeCardLayout';
import { UnlockButton } from '../Lock_Default/components/UnlockButton';

interface NoInternetLockScreenProps {
  onUnlock: () => void;
}

export const NoInternetLockScreen: React.FC<NoInternetLockScreenProps> = ({ onUnlock }) => {
  const { t } = useTranslation();

  return (
    <ThreeCardLayout
      left={<LogoTimeDate />}
      middleProps={{ alignItems: 'flex-end' }}
      middle={
        <YStack
          flex={1}
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="stretch"
          gap="$12">
          <UnlockButton text={t('lock.tapToWifi')} onUnlock={onUnlock} />
        </YStack>
      }
      right={<NoInternetConnectionView />}
    />
  );
};
